<template>
    <div class="house-status">
        <div class="house-status-wrap">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
import 'vue-range-component/dist/vue-range-slider.css'
import SearchBar from '@/components/landlord/SearchBar.vue';
import UserMenu from '@/components/landlord/UserMenu.vue';
import MessageAlarm from '@/components/landlord/MessageAlarm.vue';
import { mapGetters } from 'vuex'

export default {
    name: 'HouseStatus',
    data () {
        return {
        }
    },
    methods: {
    },
    components: {
        SearchBar,
        UserMenu,
        MessageAlarm,
    }
}
</script>
<style lang="scss" scoped>
    .house-status{
        position: relative;
        .house-status-wrap{
            padding: 40px;
        }
    }
    @media screen and (max-width: 1280px) {
        .house-status{
            .house-status-wrap{
                padding: 30px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/HouseStatus.vue